export default "__VITE_ASSET__D65Kxntq__"